<template>
  <div
    class="max-w-lg mx-auto rounded-lg shadow-lg overflow-hidden lg:max-w-none lg:flex mt-2"
  >
    <div class="bg-vlight-paper px-6 py-8 lg:flex-shrink-1 lg:p-12 lg:w-2/3">
      <h3
        class="text-2xl leading-8 font-extrabold text-gray-900 sm:text-3xl sm:leading-9"
      >
        {{ session.title }}
      </h3>
      <div class="mx-auto mt-8">
        <img :src="previewImage" class="shadow-lg mx-auto" />
      </div>

      <p class="text-base leading-6 text-gray-500 prose">
        <standard-block-content :blocks="session.description"></standard-block-content>
      </p>
      <div class="mt-8">
        <topic-grid :session="session"></topic-grid>
      </div>
      <div class="mt-10" v-if="hasTutorials">
        <tutorial-videos :session="session"></tutorial-videos>
      </div>
      <div class="mt-10">
        <session-compatibility-block :session="session"></session-compatibility-block>
      </div>
    </div>
    <div
      class="py-8 px-6 text-center bg-light-paper lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center lg:p-12 lg:w-1/3"
    >
      <details-side-bar :session="session"/>
    </div>
  </div>
</template>

<script>
import sanityImageBuilder from "../utils/sanityImageBuilder";
import DetailsSideBar from "./DetailsSideBar";
import TopicGrid from "./TopicGrid";
import SessionCompatibilityBlock from "./SessionCompatibilityBlock";
import StandardBlockContent from "./StandardBlockContent";
import TutorialVideos from "./TutorialVideos";
export default {
  name: "PreviewSessionPage",
  components: {TutorialVideos, StandardBlockContent, SessionCompatibilityBlock, TopicGrid, DetailsSideBar },
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasTutorials() {
      const tutorials = this.session.tutorials || [];
      return tutorials.length > 0;
    },
    previewImage() {
      return sanityImageBuilder
        .image(this.session.previewImage)
        .width(400)
        .url();
    },
    hasRelatedTutorials() {
      if (this.session.tutorials !== "undefined") {
        return false;
      }
      if (this.session.tutorials.length > 0) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped></style>
